module.exports = __webpack_public_path__ + "static/media/search.2c3a2624.svg";